import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

export const INVALIDATION_TAGS = {
  SETUP: 'setup',
  GET_USERS: 'getUsers',
  GET_PRODUCT_REPORT: 'getProductReport',
  GET_PRODUCT_PLAYERS_STATISTICS: 'getProductPlayerStatistics',
  GET_COUNTRIES_REPORT_LIST: 'getCountryByCountryReport',
  GET_MONTHLY_REPORT_LIST: 'getMonthByMonthReport',
  GET_MEDIA_STATISTICS_PRO: 'getMediaStatisticsPro',
  GET_REVENUE_BREAKDOWN_LIST: 'getRevenueBreakdownReport',
  GET_PRODUCT_AFFILIATE_STATISTICS_SUB: 'getProductStatisticsByAffiliateSub',
  GET_PRODUCT_STATISTICS_SUB: 'getProductStatisticsSub',
  GET_PRODUCT_STATISTICS: 'getProductStatistics',
  GET_PRODUCT_STATISTICS_DAILY: 'getProductStatisticsDaily',
  GET_PRODUCT_STATISTICS_DAILY_SUB: 'getProductStatisticsDailySub',
  GET_SUB_AFFILIATE_STATISTICS: 'getSubAffiliateStatistic',
  GET_AGENT_WALLET_INFO_AFTER_TRANSACTION: 'getAgentWalletInfoAfterTransaction',
  GET_PLAYER_WALLET_INFO_AFTER_TRANSACTION: 'getPlayerWalletInfoAfterTransaction',
  GET_BET_ODDS: 'getBetOdds',
  GET_AGENT_WALLET: 'getAgentWallet',
  GET_AGENT_ALL_WALLETS: 'getAgentAllWallets',
  GET_ALL_POSITIVE_AVAILABLE_WALLETS: 'getAllPositiveAvailableWallets',
  GET_SUB_AGENT_STATISTIC: 'getSubAgentStatistic',
  GET_PRODUCTS_LOG: 'getPartnerProductsLogs',
  GET_AFFILIATE_LIFE_TIME_LOG: 'getAffiliateLifeTimeLog',
  GET_CARRY_OVER_LOG_LIST: 'getCarryOverLogByAffiliate',
  GET_WITHDRAW_SUB_USER_LIST: 'getWithdrawListForChildren',
  GET_MY_REQUESTS_USER_LIST: 'getMyRequestsUserList',
  GET_COMMISSION_PLAN_LOG: 'getCommissionPlanLogs'
};

export const api = createApi({
  reducerPath: 'api',
  baseQuery: fetchBaseQuery({ baseUrl: '/' }),
  tagTypes: Object.values(INVALIDATION_TAGS),
  endpoints: () => ({}),
});
